import {jsonMember, jsonObject} from "typedjson";
import {DxBaseUiOptions} from "../../../../dx-page-markup/domain/ui-options/dx-base-ui-options";


/**
 * Опции бокового меню навигатора.
 * @publicApi
 */
@jsonObject
export class DxSideNavigationMenuOptions extends DxBaseUiOptions {
  @jsonMember({name: "enableMinification", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _enableMinification: boolean = true;

  @jsonMember({name: "isMinifiedByDefault", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _isMinifiedByDefault: boolean = false;

  get enableMinification(): boolean {
    return this._enableMinification;
  }

  set enableMinification(value: boolean) {
    this._enableMinification = value;
  }

  get isMinifiedByDefault(): boolean {
    return this._isMinifiedByDefault;
  }

  set isMinifiedByDefault(value: boolean) {
    this._isMinifiedByDefault = value;
  }
}
